// Deprecated. Please refrain from new usage
import React, { useState } from "react";

import { LoadingOverlay } from "../components/Navigation/LoadingOverlay";

export const withSpinner = (Component) => (props) => {
  const [shouldShow, setShouldShow] = useState();

  const timeout = 30000;

  const hideSpinner = () => {
    setShouldShow(false);
  };

  const launchSpinner = () => {
    setShouldShow(true);
    setTimeout(hideSpinner, timeout);
  };

  return (
    <>
      <Component
        {...props}
        spinner={{
          launch: launchSpinner,
          hide: hideSpinner,
          component: shouldShow ? <LoadingOverlay fullscreen={false} /> : null,
        }}
      />
    </>
  );
};
